export default __webpack_public_path__ + "static/media/Home.a2880204.svg";